"use client";

import { Card, CardContent, CardHeader, Grid } from "@mui/material";

import { PasswordResetUser } from "@/types/passwordReset";

import { usePasswordReset } from "@/context/passwordReset";
import { useEmailApi } from "@/context/passwordReset/email";
import { useRecaptcha } from "@/context/util/recaptcha";

import ForgotButton from "@/components/passwordReset/forgot/button";
import QuestionForm from "@/components/question/form";

export default function SecureForm() {
  const { showV2 } = useRecaptcha();
  const { errors, passwordResetUser, setErrors, setPasswordResetUser } =
    usePasswordReset();
  const { getUserEmails } = useEmailApi();

  const questions = passwordResetUser?.securityQuestion
    ? [passwordResetUser?.securityQuestion]
    : [];

  if (!questions.length) {
    return (
      <Grid container justifyContent="center">
        <Grid size={{ xs: 12, md: 6 }}>
          <Card sx={{ flexGrow: 1, marginBottom: 4 }}>
            <CardHeader
              title="Setup Your Security Question"
              slotProps={{ title: { fontWeight: "bold", color: "primary" } }}
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <ForgotButton
                label="I do not have a security question"
                onClick={getUserEmails}
                startIcon={<></>}
                tooltipSuffix="to setup your security question / answer and password"
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container justifyContent="center">
      <Grid size={{ xs: 12, md: 6 }}>
        <Card sx={{ flexGrow: 1, marginBottom: 4 }}>
          <CardHeader
            title="Answer Your Security Question"
            slotProps={{ title: { fontWeight: "bold", color: "primary" } }}
          />
          <CardContent sx={{ flexGrow: 1 }}>
            <QuestionForm<PasswordResetUser>
              button={
                <ForgotButton
                  label="I do not remember my security answer"
                  onClick={getUserEmails}
                  startIcon={<></>}
                  tooltipSuffix="to reset your security question / answer and password"
                />
              }
              entity={passwordResetUser}
              errors={errors}
              questionDisabled={true}
              questions={questions}
              set={setPasswordResetUser}
              setErrors={setErrors}
              showV2={showV2}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
